
import { Vue } from "vue-class-component";
export default class Health extends Vue {}
